import React from "react";
import ReactDOM from 'react-dom';
import PropTypes from "prop-types";
import CheckIcon from "adp-react-icons/lib/fa/check";
import FaTimesIcon from "adp-react-icons/lib/fa/times";
import {
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalTitle,
  Button
} from "adp-react-components";
const Entities = require('html-entities').AllHtmlEntities;
const entities = new Entities();
 class TermsConditions extends React.Component{
  constructor(props){
      super(props);
      this.state= {
      modalOpen:true,
      }
      this.closeModal=this.closeModal.bind(this);
      }

onSubmit(event){
  gtag('event', 'Enroll|TermsAndConditions|Click', {
    'event_category': 'Admin Login',
    'event_label': 'TermsAndConditions'
  });
 this.cancelModal();
  fetch(context+'/enroll/adpPassword.faces?enrollTCForm=' , {
     method: 'POST',
     //same-origin is needed to keep the cookies
     credentials: 'same-origin',

     headers: {
       'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',

        'Content-Type': 'application/x-www-form-urlencoded'
     },
     body: 'enrollTCForm=enrollTCForm&enrollTCForm:submitButton=&javax.faces.ViewState='+Tier0.get("javax.faces.ViewState").value
   }).then(response => {
       return response.json();
     }).then(data=> {
       if(data.success=="false"|| data.success==false){
         if(data.wizard.message == 'true'){
             this.props.showSessionExpired();
           return;
         }
           this.props.showErrorMessage(data.wizard.message);
           return;
       }
       });
  }
    cancelModal() {
    this.props.updateModelFlag(false);
    }
    closeModal() {
      this.props.updateModelFlag(false);
      this.props.showEnrollLoginForm();
      }

  render() {
    var generateHtml=function(html) {
        var el = document.createElement('div');
        el.innerHTML = html;
        return el.childNodes[0].nodeValue;
    }
      return (
        <div className="vdl-row login-form">
              <div className="vdl-col-md-12">
                  <form className="adp-form">
                  <Modal show={this.props.showTcModel} size='lg'>
                  <ModalHeader closeButton={ true } onHide={ this.closeModal.bind(this) } >
                  <ModalTitle>{this.props.termsConditionsTitle}</ModalTitle>
                  </ModalHeader>
                  <ModalBody>
                  <div>
                  {<div dangerouslySetInnerHTML={{ __html: (entities.decode(this.props.tnc)) }}/>}
                    </div>
                  </ModalBody>
                  <ModalFooter>

                  <div className="form-group submit vdl-text-xs-center">
                  <Button
                      className="primary"
                       onClick={ this.onSubmit.bind(this)}
                       ><CheckIcon/>{' '}
                       { this.props.accept}
                       </Button>
                      <Button buttonStyle="link" onClick={this.closeModal.bind(this)}><FaTimesIcon/>{' '}
                           { this.props.cancel}
                      </Button>

                  </div>

        </ModalFooter>
      </Modal>
      </form>
      </div>
      </div>
    );
  }
}
export default TermsConditions



// WEBPACK FOOTER //
// ./src/scenes/admin-login/enroll/term-conditions.js